import { gql } from '@apollo/client';

export const ADD_CUSTOMER_PAYMENT_METHOD = gql`
  mutation AddCustomerPaymentMethod($input: AddPaymentMethodInput!) {
    addPaymentMethodByCustomer(input: $input) {
      id
      customerId
      billingTypeId
      fullName
      address
      address2
      city
      state
      zip
      lastFour
      expMonth
      expYear
      processorCustomerId
      defaultPaymentMethod
      processorId
      createdDate
      isActive
      billingType {
        typeName
      }
      processor {
        typeName
      }
    }
  }
`;

export const ASSIGN_PAYMENT_METHOD_TO_CAMPAIGN = gql`
  mutation AssignPaymentMethodToCampaign($input: AssignPaymentMethodToCampaignInput!) {
    assignPaymentMethodToCampaign(input: $input) {
      id
      campaignId
      customerPaymentMethodId
      campaign {
        id
        name
      }
      customerPaymentMethod {
        id
        fullName
        lastFour
        defaultPaymentMethod
      }
    }
  }
`;




